import { MessageKey } from "@/i18n";
import { CountryCode, StripeAccountOwnerType, StripeAccountStatus } from "@/types";
import { BadgeColor } from "@/ui";

export const STRIPE_ACCOUNT_STATUS_LABELS: { [key in StripeAccountStatus]: MessageKey } = {
  active: "stripeConnect.filters.status.active",
  pending: "stripeConnect.filters.status.pending",
};

export const STRIPE_ACCOUNT_OWNER_TYPE_LABELS: { [key in StripeAccountOwnerType]: MessageKey } = {
  platform: "stripeConnect.filters.owner.platform",
  federation: "stripeConnect.filters.owner.federation",
  organizer: "stripeConnect.filters.owner.organizer",
};

export const BADGE_COLORS_MAP: { [key in StripeAccountStatus]: BadgeColor } = {
  active: "positive",
  pending: "warning",
};

/**
 * ISO 3166-1 alpha-2 countries where Stripe Connect connected accounts are fully available.
 */
export const STRIPE_SUPPORTED_COUNTRY_CODES = [
  "AE",
  "AG",
  "AL",
  "AM",
  "AR",
  "AT",
  "AU",
  "BA",
  "BE",
  "BG",
  "BH",
  "BJ",
  "BN",
  "BO",
  "BS",
  "BW",
  "CA",
  "CH",
  "CI",
  "CL",
  "CO",
  "CR",
  "CY",
  "CZ",
  "DE",
  "DK",
  "DO",
  "EC",
  "EE",
  "EG",
  "ES",
  "ET",
  "FI",
  "FR",
  "GB",
  "GH",
  "GM",
  "GR",
  "GT",
  "GY",
  "HK",
  "HU",
  "IE",
  "IL",
  "IS",
  "IT",
  "JM",
  "JO",
  "JP",
  "KE",
  "KH",
  "KR",
  "KW",
  "LC",
  "LK",
  "LT",
  "LU",
  "LV",
  "MA",
  "MC",
  "MD",
  "MG",
  "MK",
  "MN",
  "MO",
  "MT",
  "MU",
  "MX",
  "NA",
  "NG",
  "NL",
  "NO",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PH",
  "PK",
  "PL",
  "PT",
  "PY",
  "QA",
  "RO",
  "RS",
  "RW",
  "SA",
  "SE",
  "SG",
  "SI",
  "SK",
  "SN",
  "SV",
  "TH",
  "TN",
  "TR",
  "TT",
  "TW",
  "TZ",
  "US",
  "UY",
  "UZ",
  "VN",
  "ZA",
] as const satisfies readonly CountryCode[];

export type StripeSupportedCountryCode = (typeof STRIPE_SUPPORTED_COUNTRY_CODES)[number];

const STRIPE_SUPPORTED_COUNTRY_CODE_SET = new Set<string>(STRIPE_SUPPORTED_COUNTRY_CODES);

export const isStripeSupportedCountryCode = (
  value: string | null | undefined
): value is StripeSupportedCountryCode =>
  value != null && STRIPE_SUPPORTED_COUNTRY_CODE_SET.has(value);
